import { __extends } from './_virtual/_tslib.js';

var TokenError = /** @class */ (function (_super) {
    __extends(TokenError, _super);
    function TokenError(res) {
        var _this = _super.call(this, 'HTTP status ' + res.status) || this;
        _this.name = 'TokenError';
        _this.status = res.status;
        _this.body = res.body;
        _this.code = 'ESTATUS';
        return _this;
    }
    return TokenError;
}(Error));
var AuthError = /** @class */ (function (_super) {
    __extends(AuthError, _super);
    function AuthError(message, body) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AuthError';
        _this.body = body;
        _this.code = 'EAUTH';
        return _this;
    }
    return AuthError;
}(Error));

export { AuthError, TokenError };
